<template>
  <div>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Lista Ordini</v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-row class="mx-0" justify="center" align="center">
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-text-field
              @keyup.enter.native="goToAnagrafica"
              class="mr-2"
              label="Fornitore"
              v-model="nome_fornitore"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-2"
                  small
                  v-on="on"
                  v-bind="attrs"
                  @click="goToAnagrafica"
                  ><v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Vai al fornitore</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  v-on="on"
                  v-bind="attrs"
                  @click="getAnagrafica"
                  @keyup.enter.native="getAnagrafica"
                  ><v-icon color="primary">mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Cerca fornitore</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-data-table
          height="60vh"
          fixed-header
          :headers="headers"
          :items="ordini_vis"
          ><!-- Colonna del modifica -->
          <template v-slot:[`item.modifica`]="{ item }">
            <v-btn
              @click="
                dialog_modifica_ordine = true;
                ordine_selezionato = item;
              "
              small
              ><v-icon color="primary">mdi-pencil</v-icon></v-btn
            >
          </template>

          <!-- Colonna della data scadenza -->
          <template v-slot:[`item.data_scadenza`]="{ item }">
            {{ formatData(item.data_scadenza) }}
          </template>
        </v-data-table>
      </v-card-text>
      <!-- DIALOG RICHERCA FORNITORE -->
      <v-dialog v-model="dialogSearchAnagrafica" width="700" persistent>
        <v-card>
          <v-toolbar color="indigo" dense dark>
            <v-toolbar-title>Seleziona Fornitore</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="dialogSearchAnagrafica = false" light small>
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="ragioneSociale"
                  :items="ragioneSocialeLista"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      class="record_tabella"
                      :data-deleted="item.validita == 0 ? true : false"
                    >
                      <td>
                        <v-btn small @click="selezionaAnagrafica(item)"
                          ><v-icon color="primary">mdi-check</v-icon></v-btn
                        >
                      </td>
                      <td
                        v-for="(colonna, i) in ragioneSociale"
                        :key="i"
                        v-show="colonna.value != null"
                      >
                        {{ item[colonna.value] }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Dialog di modifica ordine -->
      <v-dialog
        v-model="dialog_modifica_ordine"
        persistent
      >
        <NuovoOrdine
          :key="dialog_modifica_ordine"
          @goBack="
            dialog_modifica_ordine = false;
            ordine_selezionato = {};
          "
          @salvataggio_effettuato="getOrdini()"
          :nuovo="false"
          :selez="ordine_selezionato.id_documento"
        />
      </v-dialog>
    </v-card>
  </div>
</template>


<script>
import moment from "moment";
import NuovoOrdine from "@/components/CREAZIONE_SF/NuovoOrdine.vue";

export default {
  name: "ListaOrdini",
  components: { NuovoOrdine },
  props: {},
  data() {
    return {
      ordini_vis: [],
      dialogSearchAnagrafica: false,
      dialog_modifica_ordine: false,
      ordine_selezionato: {},
      nome_fornitore: "",
      headers: [
        { text: "Modifica", value: "modifica" },
        { text: "Codice ordine", value: "num_documento", align: "start" },
        { text: "Fornitore", value: "ragione_sociale" },
        { text: "Data", value: "data_documento" },
      ],
      ragioneSocialeLista: [],
      ragioneSociale: [
        { text: null, value: null, align: "start" },
        { text: "Ragione Sociale", value: "ragione_sociale" },
        { text: "Cod. Fornitore", value: "codice" },
        { text: "Indrizzo", value: "indirizzo" },
      ],
    };
  },

  methods: {
    formatData(arg) {
      return arg != null && arg != "" ? moment(arg).format("DD-MM-YYYY") : "";
    },
    getOrdini() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getdocumento",
          token: localStorage.getItem("user_token"),
          id_anagrafica: this.id_anagrafica,
          cod_documento: "ORDF",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.ordini_vis =
            res.data.documento[0].id_documento == -1 ? [] : res.data.documento;
          this.ordini_vis.forEach((e) => {
            e.id_anagrafica = this.id_anagrafica;
          });
        }
      });
    },

    goToAnagrafica() {
      if (this.nome_fornitore === "" || this.nome_fornitore === null) {
        return;
      }

      // this.overlay = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",

          token: localStorage.getItem("user_token"),
          des_anagrafica: this.nome_fornitore,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;

        if (res.data.length > 1) {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Sono presenti più fornitori con questo nome.";
          this.snackbar_text_color = "white";
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }

        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            "Non sono stati trovati fornitori con questo nome.";
          this.snackbar_text_color = "white";
        }

        if (res.data.length === 1) {
          this.id_anagrafica = res.data[0].id_anagrafica;
          this.getOrdini();
          this.dialogSearchAnagrafica = false;
        }
      });
    },

    getAnagrafica() {
      let searchReq = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getragionesociale",
          token: localStorage.getItem("user_token"),
          des_anagrafica: this.nome_fornitore,
          tipo_anagrafica: "F",
        },
      };
      this.$store.dispatch("api", searchReq).then((res) => {
        if (res.data.length === 0) {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Il Fornitore non è stato trovato. Riprova!";
          this.snackbar_text_color = "white";
        }
        if (res.data.length > 1) {
          this.ragioneSocialeLista = res.data;
          this.dialogSearchAnagrafica = true;
        }
        if (res.data.length == 1) {
          this.id_anagrafica = res.data[0].id_anagrafica;
          this.getOrdini();
        }
      });
    },

    selezionaAnagrafica(item) {
      this.id_anagrafica = item.id_anagrafica;
      this.getOrdini();
      this.dialogSearchAnagrafica = false;
    },
  },
};
</script>

